import { styled, TableCell, TableHead } from '@mui/material';

export const StickyTableHead = styled(TableHead)(() => ({
  position: 'sticky',
  top: 0,
  zIndex: 10,
}));

export const TableCellStyledBody = styled('div', { shouldForwardProp: (prop) => prop !== 'hasEnabled_F202718' })<{ hasEnabled_F202718: boolean }>(
  ({ hasEnabled_F202718 }) => ({
    width: '100%',
    padding: hasEnabled_F202718 ? '0' : '8px',
    display: 'flex',
    alignItems: 'center',
  })
);

export const StyledTableCell = styled(TableCell)(() => ({
  padding: '8px',
}));
